let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5u7RJ")).then(() => parcelRequire('74Awr'));